export default __webpack_public_path__ + "20800bf5f71e52ab072d122b38436cc1.png";